import {
  BoxProps,
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { GrAddCircle, GrAdd } from "react-icons/gr";

export const GamCampaignHomeHeader = (props: BoxProps) => {

    return (
      <Flex
        justifyContent={"space-between"}
        align={"center"}
        mb={[3, null, null, 5, null]}
        minW={"100%"}
        {...props}
      >
        <HStack>
          <Text fontWeight={"medium"} fontSize={["2xl", null, null, "2xl", null]}>
            Campaigns
          </Text>
        </HStack>
        <HStack>
          <Link to={"new"}>
            <IconButton
              aria-label={"link to new campaign form"}
              icon={<GrAdd />}
              variant={"primary"}
              display={["flex", null, "none", null, null]}
            />

            <Button
              variant={"blueButton"}
              size={"sm"}
              leftIcon={<Icon as={GrAddCircle} />}
              display={["none", null, "flex", null, null]}
            >
              New Campaign
            </Button>
          </Link>
        </HStack>
      </Flex>
    );
}
